import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { initBasketUnsubscribesAction } from 'reducks/basket/actions'

const unsubscribeBaskets = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const unsubscribes = getState().basket.unsubscribes
    unsubscribes.map((unsubscribe: () => void) => unsubscribe())
    dispatch(initBasketUnsubscribesAction())
  }
}

export default unsubscribeBaskets
